// Textos de la revisión de los viajes de empresa de Taxi / VTC: bandeja de la
// empresa, detalle, rechazo y ajustes globales de WAIIS. Se registran junto al
// resto de vocabularios en AppComponent.
export const locale = {
  lang: 'ca',
  data: {
    RIDE_REVIEWS: {
      TITLE: 'Revisió intel·ligent de viatges',
      RETRY: 'Torna-ho a provar',
      LOAD_ERROR: 'No s’han pogut carregar els viatges per revisar.',
      KPIS_ERROR: 'No s’han pogut carregar els indicadors.',
      BADGE: {
        RED: 'Revisió obligatòria',
        ORANGE: 'Revisió recomanada',
        YELLOW: 'Aprovat · baixa sospita',
        GREEN: 'Aprovat automàticament',
        APPROVED: 'Aprovat per l’empresa',
        REJECTED: 'Rebutjat per l’empresa',
      },
      KPI: {
        ANALYZED: 'Viatges analitzats · 30 dies',
        ANALYZED_HINT: 'Tots els que paga l’empresa',
        AUTO: 'Aprovats sense intervenció',
        AUTO_HINT: '{{count}} amb baixa sospita, registrats',
        AUTO_HINT_ONE: '1 amb baixa sospita, registrat',
        PENDING: 'Necessiten la teva decisió',
        PENDING_HINT: '{{count}} obligatòries',
        PENDING_HINT_ONE: '1 obligatòria',
        NOTHING_PENDING: 'Res pendent',
      },
      FILTER: {
        ARIA: 'Quins viatges veure',
        PENDING: 'Pendents',
        RED: 'Obligatòria',
        ORANGE: 'Recomanada',
        YELLOW: 'Baixa sospita',
        RESOLVED: 'Resolts',
      },
      HOW: {
        TITLE: 'Com funciona',
        GREEN: 'Encaixa amb l’horari, l’origen, la destinació i el cost habituals. No el veus.',
        YELLOW: 'Una desviació menor. S’aprova i queda registrat.',
        ORANGE: 'Diversos senyals atípics. Convé mirar-ho.',
        RED: 'Fora de la política o possible ús personal. Decideixes tu.',
        GREEN_TITLE: 'Aprovat automàticament',
        YELLOW_TITLE: 'Baixa sospita',
        NOTE: 'Perquè funcioni, l’app demana a l’empleat un motiu en cada viatge amb pagament d’empresa i una justificació quan el viatge surt del seu patró.',
      },
      CARD: {
        REASON: 'Motiu declarat',
        JUSTIFICATION: 'Justificació',
        NO_JUSTIFICATION: 'No aportada',
        PAID_BY_COMPANY: 'Pagat per l’empresa',
        PLUS_EMPLOYEE: '+ {{amount}} empleat',
        POINTS: '{{count}} pts',
        POINTS_ONE: '1 pt',
        APPROVE: 'Aprova',
        REJECT: 'Rebutja',
        DETAIL: 'Mostra el detall',
        NO_REASON: 'Sense motiu',
      },
      EMPTY: {
        PENDING_TITLE: 'Res per revisar',
        PENDING: 'Tots els viatges que paga l’empresa encaixen amb el patró de cada empleat.',
        OTHER_TITLE: 'Cap viatge aquí',
      },
      MORE: 'Mostra’n més',
      SHOWING: 'Es mostren {{shown}} de {{total}} viatges',
      SHOWING_ONE: 'Es mostra {{shown}} d’1 viatge',
      APPROVED_OK: 'Viatge de {{name}} aprovat',
      APPROVE_ERROR: 'No s’ha pogut aprovar el viatge',
      REJECTED_OK: 'Viatge rebutjat: es reclamarà l’import a l’empleat i se l’avisarà',
      REJECT_ERROR: 'No s’ha pogut rebutjar el viatge',
      ALREADY_DECIDED: 'Aquest viatge ja té una decisió',
      ACCEPT: 'D’acord',
      DETAIL: {
        CLOSE: 'Tanca',
        LOAD_ERROR: 'No s’ha pogut carregar el viatge.',
        SIGNALS: 'Senyals',
        HARD_RULES: 'Regles que obliguen a revisar-lo',
        SCORE: 'Puntuació',
        SCORE_VALUE: '{{count}} punts',
        SCORE_VALUE_ONE: '1 punt',
        PRODUCT: 'Servei',
        REVIEW: 'Revisió',
        DECISION: 'Decisió',
        DECIDED_BY: '{{name}} · {{date}}',
        REJECT_REASON: 'Motiu del rebuig',
        REJECT_MESSAGE: 'Missatge a l’empleat',
        PAYMENT: 'Repartiment del pagament',
        COMPANY: 'Empresa',
        EMPLOYEE: 'Targeta de l’empleat',
        NO_AMOUNT: 'Encara sense import',
      },
      REJECT: {
        TITLE: 'Rebutja el viatge',
        INTRO: 'Rebutjaràs el viatge de {{name}} · {{route}}. El que va pagar l’empresa es reclamarà a l’empleat i se l’avisarà.',
        REASON: 'Motiu',
        REASON_HINT: 'S’envia a l’empleat',
        REASON_REQUIRED: 'Tria un motiu.',
        MESSAGE: 'Missatge per a l’empleat',
        MESSAGE_PLACEHOLDER: 'Missatge per a l’empleat (opcional)…',
        CANCEL: 'Cancel·la',
        SUBMIT: 'Rebutja i notifica',
        SUBMITTING: 'S’està rebutjant…',
      },
      REASON: {
        personal_trip: 'Viatge personal, no corporatiu',
        carpooling_available: 'Hi havia cotxe compartit disponible',
        outside_policy_schedule: 'Fora de l’horari de la política',
        missing_justification: 'Falta la justificació',
        unauthorized_cost: 'Cost no autoritzat',
      },
      SIGNAL: {
        weekend: 'Viatge en cap de setmana',
        night: 'Horari de matinada',
        unrelated_origin: 'Origen sense relació amb una seu, una estació o un lloc conegut',
        unrelated_destination: 'Destinació sense relació amb una seu, una estació o un lloc conegut',
        cost_above_average: 'Cost superior a la mitjana de l’empleat',
        duplicate: 'Possible duplicitat amb un altre viatge gairebé idèntic',
        excessive_use: 'Més viatges d’empresa dels permesos aquesta setmana',
        missing_justification: 'Sense justificació en un viatge atípic',
      },
      HARD_RULE: {
        unrelated_destination_without_justification: 'Destinació no relacionada sense justificació',
        off_hours_unrelated_trip: 'Cap de setmana o matinada amb origen i destinació no relacionats',
        duplicate: 'Possible viatge duplicat',
        cost_double_without_justification: 'Cost del doble de la mitjana o més sense justificació',
      },
      SETTINGS: {
        NOTE_TITLE: 'Valen per a totes les empreses',
        NOTE_TEXT: 'Canviar-los només afecta els viatges que es puntuïn a partir d’ara: els ja revisats conserven els seus punts.',
        LOAD_ERROR: 'No s’han pogut carregar els ajustos de la revisió.',
        SAVE: 'Desa els canvis',
        SAVING: 'S’està desant…',
        SAVED: 'Ajustos de la revisió desats',
        SAVE_ERROR: 'No s’han pogut desar els ajustos',
        REQUIRED: 'Obligatori.',
        POINTS_TITLE: 'Punts per senyal',
        POINTS_SUB: 'El que suma cada senyal quan salta.',
        POINT: {
          weekend: 'Cap de setmana',
          night: 'Matinada',
          unrelatedOrigin: 'Origen no relacionat',
          unrelatedDestination: 'Destinació no relacionada',
          duplicate: 'Duplicitat',
          excessiveUse: 'Ús excessiu',
          missingJustification: 'Sense justificació',
        },
        LEVELS_TITLE: 'Nivells',
        LEVELS_SUB: 'Punts a partir dels quals un viatge passa a cada nivell. El taronja i el vermell queden pendents de l’empresa.',
        LEVEL_YELLOW: 'Baixa sospita des de',
        LEVEL_ORANGE: 'Revisió recomanada des de',
        LEVEL_RED: 'Revisió obligatòria des de',
        COST_TITLE: 'Cost',
        COST_SUB: 'Comparació amb la mitjana dels altres viatges d’empresa de l’empleat.',
        COST_STEP: 'Graó {{n}}',
        COST_STEP_PCT: '% sobre la mitjana',
        COST_STEP_POINTS: 'Punts',
        COST_HARD_RULE: '% sobre la mitjana que obliga a revisar sense justificació',
        COST_HISTORY_DAYS: 'Dies d’historial',
        COST_MIN_RIDES: 'Viatges mínims per calcular la mitjana',
        SCHEDULE_TITLE: 'Horari i ús',
        SCHEDULE_SUB: 'Matinada i nombre de viatges per setmana.',
        NIGHT_END_HOUR: 'La matinada acaba a les (hora)',
        MAX_WEEKLY_RIDES: 'Viatges per setmana permesos',
        DISTANCES_TITLE: 'Distàncies',
        DISTANCES_SUB: 'Quan un punt és a prop d’un lloc relacionat i quan dos viatges són el mateix.',
        PLACE_RADIUS: 'Radi d’un lloc relacionat (m)',
        DUPLICATE_RADIUS: 'Radi d’un viatge duplicat (m)',
        DUPLICATE_MINUTES: 'Minuts entre viatges duplicats',
        STATIONS_TITLE: 'Estacions',
        STATIONS_SUB: 'Quines parades compten com a lloc relacionat. Sense cap marcada, no en compta cap.',
        STATION: {
          bus_stop: 'Parades d’autobús',
          train_station: 'Estacions de tren',
          metro_station: 'Estacions de metro',
        },
        PLACES_TITLE: 'Llocs coneguts',
        PLACES_SUB: 'A més de les seus i les estacions, per a totes les empreses.',
        PLACE_NAME: 'Nom',
        PLACE_LAT: 'Latitud',
        PLACE_LNG: 'Longitud',
        PLACE_ADD: 'Afegeix un lloc',
        PLACE_REMOVE: 'Treu {{name}}',
        PLACES_EMPTY: 'Cap lloc conegut.',
      },
    },
  },
};
